import { useState, useEffect } from "react";
import { Section } from "../types";
import { fetchSections, createSection } from "../services/sectionsService";

export const useSections = () => {
  const [sections, setSections] = useState<Section[]>([]);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await fetchSections();
        setSections(data);
      } catch (err) {
        setError("Failed to load sections.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const isDuplicateName = (name: string) => {
    const normalized = name.trim().toLowerCase();
    return sections.some((section) => section.name.trim().toLowerCase() === normalized);
  };

  const create = async (code: string, name: string, description: string) => {
    setCreating(true);
    setError(null);
    try {
      await createSection({ code, name: name.trim(), description: description.trim() });
      const data = await fetchSections();
      setSections(data);
      return true;
    } catch (err) {
      setError("Failed to create section.");
      return false;
    } finally {
      setCreating(false);
    }
  };

  return {
    sections,
    loading,
    creating,
    error,
    isDuplicateName,
    actions: {
      create,
    },
  };
};
